export default __webpack_public_path__ + "8c3f0a241af0847852f0b4e9be26fe34.svg";